/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import {
  LG_SCREEN_MIN,
  MD_SCREEN_MAX,
  MD_SCREEN_MIN,
} from '../../../../modules/Styleguide';
import { CDN_PATH } from '../constants';
import { PageHeader, Section, SectionContent } from '../styled';

export function HeroSection() {
  return (
    <StyledSection>
      <StyledSectionContent>
        <PageHeader>Tools designed for every podcaster.</PageHeader>
        <picture
          css={css`
            text-align: center;
          `}
        >
          <source
            type="image/webp"
            srcSet={`${CDN_PATH}/anchor-devices.webp`}
            media="(min-width: 992px)"
          />
          <source
            srcSet={`${CDN_PATH}/anchor-devices.png`}
            media="(min-width: 992px)"
          />
          <source
            type="image/webp"
            srcSet={`${CDN_PATH}/anchor-devices-mobile.webp`}
          />
          <img
            css={css`
              align-self: center;
            `}
            alt="devices showcasing Anchor app"
            src={`${CDN_PATH}/anchor-devices-mobile.png`}
          />
        </picture>
      </StyledSectionContent>
    </StyledSection>
  );
}

const StyledSection = styled(Section)`
  background: linear-gradient(180deg, #5c1dbe 0.99%, #8940fa 99.68%);
  margin-top: 52px;
  height: 305px;
  h1 {
    color: white;
  }
  @media (min-width: ${LG_SCREEN_MIN}px) {
    height: 358px;
  }
`;

const StyledSectionContent = styled(SectionContent)`
  flex-direction: column;
  h1 {
    width: 100%;
    padding-top: 48px;
    padding-bottom: 20px;
  }
  img {
    align-self: center;
    width: 90%;
  }
  @media (min-width: ${MD_SCREEN_MIN}px) and (max-width: ${MD_SCREEN_MAX}px) {
    h1 {
      text-align: center;
    }
    img {
      width: 516px;
    }
  }
  @media (min-width: ${LG_SCREEN_MIN}px) {
    flex-direction: row;
    h1 {
      width: 390px;
      padding-top: 75px;
    }
    img {
      margin-top: 90px;
      max-width: 861px;
    }
  }
`;
